module.exports = __webpack_public_path__ + "static/media/thematic_funds.2bfc6efc.svg";